import MasterLayout from "_metronic/layout/MasterLayout";
import ExternalAccessCommentPage from "app/modules/shared/externalAccess/comment/ExternalAccessCommentPage";
import ExternalAccessPasswordChangePage from "app/modules/shared/externalAccess/password/ExternalAccessPasswordChangePage";
import { ReactElement } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

const ExternalAccessComponents: { [name: string]: ReactElement } = {
  comment: <ExternalAccessCommentPage />,
  passwordchange: <ExternalAccessPasswordChangePage />,
};

type ExternalAccessRoutesProps = {
  allowedRoute: string;
};

const ExternalAccessRoutes: React.FC<ExternalAccessRoutesProps> = ({ allowedRoute }) => {
  const externalAccessComponent = ExternalAccessComponents[allowedRoute];
  return (
    <Routes>
      <Route element={<MasterLayout externalAccess />}>
        <Route
          path={allowedRoute}
          element={externalAccessComponent ? externalAccessComponent : <Navigate to="/error/404" />}
        />
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );
};

export default ExternalAccessRoutes;
